import { Skeleton } from 'components';
import { VStack } from 'components/ui';

export const AiPromoSkeleton = () => {
  return (
    <>
      <VStack spacing="xs">
        <Skeleton width="300px" height="24px" />
        <Skeleton width="150px" height="24px" />
      </VStack>
      <VStack spacing="xxs">
        <Skeleton width="60%" height="20px" />
        <Skeleton width="70%" height="20px" />
        <Skeleton width="90%" height="20px" />
        <Skeleton width="50%" height="20px" />
        <Skeleton width="100%" height="20px" />
        <Skeleton width="95%" height="20px" />
        <Skeleton width="40%" height="20px" />
        <Skeleton width="90%" height="20px" />
      </VStack>
    </>
  );
};
